module.exports = __webpack_public_path__ + "static/st-paul-51c277b170c10d9bd0be6db8f4e510df.png";